import React from 'react';
import TextComponent from 'shared/components/TextComponent';
import { arrayXqty } from 'shared/data/tooltips';

const ArrayXQuantity = (props) => {
  const name = 'array_x_qty';
  const {
    parameters,
    errorMessage,
    label,
    inputId,
    required,
    onChangeParameter,
    groupName,
    tooltip,
    className,
    inputClassName,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      inputId={inputId}
      type="number"
      value={parameters[name] || ''}
      required={required}
      groupName={groupName}
      onChange={onChange}
      tooltip={tooltip}
      className={className}
      inputClassName={inputClassName}
      errorMessage={errorMessage}
      disabled={disabled} />
  );
};

ArrayXQuantity.defaultProps = {
  label: '# of up in X',
  tooltip: arrayXqty,
};

export default ArrayXQuantity;
